"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("../utils");
var _image = _interopRequireDefault(require("./image"));
var _personLite = _interopRequireDefault(require("./person-lite"));
var _productLine = _interopRequireDefault(require("./product-line"));
var _product = _interopRequireDefault(require("./product"));
var _processRichText = _interopRequireDefault(require("../utils/process-rich-text"));
var _standard = _interopRequireDefault(require("../utils/rich-text-factories/standard"));
var _entityLite = require("./entity-lite");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var dateFormatter = new Intl.DateTimeFormat('en-GB', {
  day: 'numeric',
  month: 'long',
  year: 'numeric'
});
var getTag = function getTag(_ref) {
  var _fields$topics, _fields$topics$, _fields$topics$$field, _fields$subLevel, _fields$subLevel$fiel, _fields$parent, _fields$parent$fields, _fields$subCategory, _fields$subCategory$f, _fields$category, _fields$category$fiel;
  var sys = _ref.sys,
    fields = _ref.fields;
  var contentType = sys.contentType.sys.id;
  var options = {
    helpPost: ((_fields$topics = fields.topics) === null || _fields$topics === void 0 ? void 0 : (_fields$topics$ = _fields$topics[0]) === null || _fields$topics$ === void 0 ? void 0 : (_fields$topics$$field = _fields$topics$.fields) === null || _fields$topics$$field === void 0 ? void 0 : _fields$topics$$field.title) || null,
    page_v2: ((_fields$subLevel = fields.subLevel) === null || _fields$subLevel === void 0 ? void 0 : (_fields$subLevel$fiel = _fields$subLevel.fields) === null || _fields$subLevel$fiel === void 0 ? void 0 : _fields$subLevel$fiel.title) || ((_fields$parent = fields.parent) === null || _fields$parent === void 0 ? void 0 : (_fields$parent$fields = _fields$parent.fields) === null || _fields$parent$fields === void 0 ? void 0 : _fields$parent$fields.title) || null,
    productPage: ((_fields$subCategory = fields.subCategory) === null || _fields$subCategory === void 0 ? void 0 : (_fields$subCategory$f = _fields$subCategory.fields) === null || _fields$subCategory$f === void 0 ? void 0 : _fields$subCategory$f.title) || ((_fields$category = fields.category) === null || _fields$category === void 0 ? void 0 : (_fields$category$fiel = _fields$category.fields) === null || _fields$category$fiel === void 0 ? void 0 : _fields$category$fiel.title) || null
  };
  return options[contentType] || null;
};
var getLinkedItemContent = function getLinkedItemContent(_ref2) {
  var _contentMap$type;
  var sys = _ref2.sys,
    fields = _ref2.fields;
  var type = fields.pageType || sys.contentType.sys.id;
  var contentMap = {
    blogPost: function blogPost() {
      var publishDate = new Date(fields.publishedAt || sys.createdAt);
      return !Number.isNaN(publishDate.getTime()) ? dateFormatter.format(publishDate) : null;
    },
    person: function person() {
      return (0, _utils.getProp)(fields, 'jobTitle');
    }
  };
  return ((_contentMap$type = contentMap[type]) === null || _contentMap$type === void 0 ? void 0 : _contentMap$type.call(contentMap)) || (0, _utils.getProp)(fields, 'shortDescription');
};
var createLinkedItem = function createLinkedItem(_ref3) {
  var sys = _ref3.sys,
    fields = _ref3.fields;
  return _objectSpread(_objectSpread({}, (0, _entityLite.createEntityLite)({
    sys: sys,
    fields: fields
  })), {}, {
    image: (0, _utils.getProp)(fields, 'image') ? (0, _image["default"])(fields.image) : null,
    title: (0, _utils.getProp)(fields, 'title') || (0, _utils.getProp)(fields, 'name'),
    tag: getTag({
      sys: sys,
      fields: fields
    }),
    content: getLinkedItemContent({
      sys: sys,
      fields: fields
    })
  });
};
var priceFactories = {
  product: _product["default"],
  productLine: _productLine["default"]
};
var getItem = function getItem(factoryMap, item) {
  var _item$sys, _item$sys$contentType, _item$sys$contentType2;
  var contentType = item === null || item === void 0 ? void 0 : (_item$sys = item.sys) === null || _item$sys === void 0 ? void 0 : (_item$sys$contentType = _item$sys.contentType) === null || _item$sys$contentType === void 0 ? void 0 : (_item$sys$contentType2 = _item$sys$contentType.sys) === null || _item$sys$contentType2 === void 0 ? void 0 : _item$sys$contentType2.id;
  var factory = factoryMap[contentType];
  return factory ? factory(item) : null;
};
var getContent = function getContent(document) {
  if ((document === null || document === void 0 ? void 0 : document.nodeType) === 'document') {
    return (0, _processRichText["default"])({
      document: document,
      factories: _standard["default"]
    });
  }
  return document;
};
var createSource = function createSource(fields) {
  var internalSource = fields.internalSource ? (0, _personLite["default"])(fields.internalSource) : null;
  var externalSourceName = (0, _utils.getProp)(fields, 'externalSourceName');
  if (!internalSource && !externalSourceName) return null;
  return {
    internal: !!internalSource,
    image: (0, _utils.getProp)(internalSource, 'image'),
    name: (0, _utils.getProp)(internalSource, 'name') || externalSourceName,
    jobTitle: (0, _utils.getProp)(internalSource, 'jobTitle'),
    location: (0, _utils.getProp)(fields, 'externalSourceLocation'),
    date: (0, _utils.getProp)(fields, 'externalSourceDate')
  };
};

/**
 * Creates a `card` content model
 *
 * @param {object} entry
 * @param {object} entry.sys
 * @param {string} entry.sys.id
 * @param {object} entry.sys.contentType
 * @param {object} entry.sys.contentType.sys
 * @param {string} entry.sys.contentType.sys.id
 * @param {object} entry.fields
 * @param {string} entry.fields.cardType - The type of card
 * @param {string} entry.fields.backgroundColour - The background colour for the card
 * @param {string} entry.fields.textColour = The text colour for the card
 * @param {object} entry.fields.image - The override image for the card
 * @param {string} entry.fields.title - The override title for the card
 * @param {string} entry.fields.content - The override content for the card
 * @param {string} entry.fields.callToActionText - The call to action text for the card
 * @param {string} entry.fields.callToActionButtonVariation - The call to action button variation
 * @param {object} entry.fields.price - A reference to a model with pricing data
 * @param {object} entry.fields.link - A reference to another content model
 * @param {object} entry.fields.callToActionExternalLink - A reference to external link
 * @param {object} entry.fields.secondaryCallToActionInternalLink - A reference to internal link
 * @param {object} entry.fields.secondaryCallToActionExternalLink - A reference to external link
 * @param {string} entry.fields.secondaryCallToActonText - Text for the secondary link
 * @param {boolean} entry.fields.showSecondaryCallToActionWithIcon - icon with secondary cta link
 * @returns {object} - `card` content model
 */
var createCard = function createCard(_ref4) {
  var _sys$contentType;
  var sys = _ref4.sys,
    fields = _ref4.fields;
  var linkedItem = fields.link ? createLinkedItem(fields.link) : null;
  var priceItem = fields.price ? getItem(priceFactories, fields.price) : null;
  var source = createSource(fields);
  var cardType = (0, _utils.getProp)(fields, 'cardType');
  var document = (0, _utils.getProp)(fields, 'content');
  var secondaryCallToActionInternalLinkItem = fields.secondaryCallToActionInternalLink ? createLinkedItem(fields.secondaryCallToActionInternalLink) : null;
  return _objectSpread(_objectSpread({
    id: (0, _utils.getProp)(sys, 'id'),
    contentType: (0, _utils.getProp)(sys === null || sys === void 0 ? void 0 : (_sys$contentType = sys.contentType) === null || _sys$contentType === void 0 ? void 0 : _sys$contentType.sys, 'id'),
    cardType: cardType,
    backgroundColour: (0, _utils.getProp)(fields, 'backgroundColour'),
    image: (0, _utils.getProp)(fields, 'image') ? (0, _image["default"])(fields.image) : (0, _utils.getProp)(linkedItem, 'image'),
    title: (0, _utils.getProp)(fields, 'title') || (0, _utils.getProp)(linkedItem, 'title'),
    content: getContent(document) || (0, _utils.getProp)(linkedItem, 'content'),
    priceItem: priceItem,
    callToActionText: (0, _utils.getProp)(fields, 'callToActionText'),
    callToActionButtonVariation: (0, _utils.getProp)(fields, 'callToActionButtonVariation'),
    callToActionIcon: (0, _utils.getProp)(fields, 'callToActionIcon'),
    link: (0, _utils.getProp)(linkedItem, 'url'),
    tag: (0, _utils.getProp)(linkedItem, 'tag'),
    callToActionExternalLink: (0, _utils.getProp)(fields, 'callToActionExternalLink'),
    secondaryCallToActionInternalLink: (0, _utils.getProp)(secondaryCallToActionInternalLinkItem, 'url'),
    secondaryCallToActionExternalLink: (0, _utils.getProp)(fields, 'secondaryCallToActionExternalLink'),
    secondaryCallToActionText: (0, _utils.getProp)(fields, 'secondaryCallToActionText'),
    showSecondaryCallToActionWithIcon: (0, _utils.getProp)(fields, 'showSecondaryCallToActionWithIcon'),
    textColour: (0, _utils.getProp)(fields, 'textColour')
  }, cardType === 'comparison' ? {
    comparisons: {
      whatIsIt: (0, _utils.getProp)(fields, 'comparisonWhatIsIt'),
      whoFor: (0, _utils.getProp)(fields, 'comparisonWhoFor'),
      whereToGetIt: (0, _utils.getProp)(fields, 'comparisonWhereToGetIt'),
      symptoms: (0, _utils.getProp)(fields, 'comparisonSymptoms'),
      howToUse: (0, _utils.getProp)(fields, 'comparisonHowToUse'),
      periods: (0, _utils.getProp)(fields, 'comparisonPeriods'),
      sideEffects: (0, _utils.getProp)(fields, 'comparisonSideEffects'),
      effectiveness: (0, _utils.getProp)(fields, 'comparisonEffectiveness')
    }
  } : {}), {}, {
    source: source
  });
};
var _default = createCard;
exports["default"] = _default;